import { render, staticRenderFns } from "./RealmPicker.vue?vue&type=template&id=536d8c5f&scoped=true"
import script from "./RealmPicker.vue?vue&type=script&lang=ts"
export * from "./RealmPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d8c5f",
  null
  
)

export default component.exports